var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 29,
    viewBox: "0 0 19 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_827_6347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9326 8.82491H5.2094L7.91857 6.10816L6.85155 5.04114L2.31104 9.58166L6.85155 14.1222L7.91857 13.0552L5.2094 10.3384H15.9326V8.82491Z",
    fill: "#424A53"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_827_6347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06741 18.6616H13.7906L11.0814 15.9448L12.1484 14.8778L16.689 19.4183L12.1484 23.9589L11.0814 22.8918L13.7906 20.1751H3.06741V18.6616Z",
    fill: "#424A53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_827_6347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1621,
    height: 18.1621,
    fill: "white",
    transform: "translate(0.0410156 0.50061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_827_6347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1621,
    height: 18.1621,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.959 10.3373)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareIcon);
export default __webpack_public_path__ + "static/media/compare-icon.7b842027cfabbcb044e14b500a9dd4ab.svg";
export { ForwardRef as ReactComponent };